import { enqueueSnackbar, UploadMultipleFiles } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetLogsLastUpdateRequest,
	UploadLogsRequest,
	GetMoBacthScriptsRequest
} from '../requests/UploadLogsRequests.js';

export const GET_LOGS_LAST_UPDATE = 'GET_LOGS_LAST_UPDATE';

const onGetLogsLastUpdate = (value) => ({
	type: GET_LOGS_LAST_UPDATE,
	logsLastUpdate: value
});

export const GetLogsLastUpdate = () => async (dispatch) => {
	await GetLogsLastUpdateRequest().then(response => {
		dispatch(onGetLogsLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetMoBacthScripts = () => async (dispatch) => {
	await GetMoBacthScriptsRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunUploadLogFiles = (filesPath, userId) => async (dispatch) => {
	await UploadLogsRequest(filesPath, userId).then(response => {
		dispatch(enqueueSnackbar({ message: `Successfully parsed ${response.data} files.`, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadLogFiles = (files, userId) => async (dispatch) => {
	await UploadMultipleFiles(files).then(response => {
		dispatch(RunUploadLogFiles(response.data, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
